import Barcode from 'react-barcode';
import { datinNumber, templateMock } from './constant';
import BoxitImage from '../../assets/images/boxit.jpg'
const PdfTemplate5 = ({ data, userInfo }: any) => {
  const renderData = data || templateMock;
  return (
    <>
      {renderData &&
        renderData.map((item: any) => (
          <div className='flex justify-center items-center flex-col  gap-y-4  p-5'>

          <div className="templates  [&>div]:text-[8pt]   flex flex-col   w-[13.5cm] h-[8.4cm] ">
            <div className="  border border-Black87   h-[1.4cm] flex  items-center  justify-between  p-2 ">
              <img src={BoxitImage} width={80} height={12} />
              <div className=" font-semibold text-[9pt] ">
                شماره پشتیبانی :{' '}
                {userInfo?.text === 'datin' || userInfo?.text === datinNumber ? '02124597775' : '90007030'}
              </div>
            </div>
            <div className="flex  border border-Black87">
              <div className="flex flex-col flex-1 ">
                <div className="flex h-[1.2cm]">
                  <div className=" w-[6cm] flex items-center   p-1 border border-Black87">
                    <span className=" font-semibold">گیرنده: </span>
                    <span className=" mr-1"> {item.receiverProspectName} </span>
                  </div>
                  <div className=" w-[4cm] flex items-center   p-1 border border-Black87">
                    <span className=" font-semibold">فرستنده: </span>
                    <span className=" mr-1"> {item.senderName} </span>
                  </div>
                  <div className=" w-[2cm] flex items-center justify-center flex-1   p-1 border border-Black87">
                    {!data ? (
                      <>
                        <span className=" font-semibold">ردیف چاپی: </span>
                        <span className=" mr-1">{item?.printIndex}</span>
                      </>
                    ) : (
                      <span>{item?.printIndex}</span>
                    )}
                  </div>
                </div>
                <div className="flex ">
                  <div className="h-[1.2cm] w-[6cm] flex items-center  p-1 border border-Black87">
                    <span className=" font-semibold">استان و شهر گیرنده: </span>
                    <span className=" mr-1">
                      {item.receiverState?.text
                        ? `${item.receiverState.text}-${item.receiverCityName || ''}`
                        : item.receiverCityName || ''}
                    </span>
                  </div>
                  <div className="h-[1.2cm] w-[6cm] flex items-center  p-1 border border-Black87">
                    <span className=" font-semibold">استان و شهر فرستنده: </span>
                    <span className=" mr-1">{item.senderCityName}</span>
                  </div>
                </div>
                <div className="flex h-[1.4cm] ">
                  <div className=" w-[6cm] flex items-start  p-1 border border-Black87">
                    <span className=" font-semibold"> آدرس: </span>
                    <span className=" mr-1    w-5/6 break-words ">{item.receiverAddress}</span>
                  </div>
                  <div className=" w-[6cm] flex items-start  p-1 border border-Black87">
                    <span className=" font-semibold"> آدرس: </span>
                    <span className=" mr-1 w-5/6 break-words ">{item.senderAddress}</span>
                  </div>
                </div>
                <div className="flex h-[1.4cm] ">
                  <div className=" w-[3cm] flex items-start flex-col gap-1  p-1 border border-Black87">
                    <span className=" font-semibold"> موبایل گیرنده: </span>
                    <span className=" mr-1">{item.receiverProspectMobile}</span>
                  </div>
                  <div className=" w-[3cm] flex items-start  flex-col gap-1 p-1 border border-Black87">
                    <span className=" font-semibold"> کد پستی: </span>
                    <span className=" mr-1"></span>
                  </div>
                  <div className=" w-[3cm] flex flex-col gap-1 items-start  p-1 border border-Black87">
                    <span className=" font-semibold"> موبایل فرستنده: </span>
                    <span className=" mr-1">{item.senderMobile}</span>
                  </div>
                  <div className=" w-[3cm] flex items-start flex-col gap-1  flex-1 p-1 border border-Black87">
                    <span className=" font-semibold"> کد پستی: </span>
                    <span className=" mr-1"></span>
                  </div>
                </div>

                <div className="flex h-[1.8cm] ">
                  <div className=" w-[1.5cm] flex items-start   p-1 border border-Black87 flex-col">
                    <span className=" font-semibold text-[6pt]"> هزینه پس کرایه (ریال): </span>
                    <span className=" mr-1 text-[6pt]">
                      {item.paymentBy?.id === 0 ? '' : ` ${item.grossPrice?.toLocaleString()}`}
                    </span>
                  </div>
                  <div className=" w-[1.5cm] flex flex-col items-start   p-1 border border-Black87">
                    <span className=" font-semibold text-[6pt]"> هزینه کالا (ریال): </span>
                    <span className=" mr-1 text-[6pt]">{item.costOfGoods?.toLocaleString() || ''}</span>
                  </div>
                  <div className=" w-[3cm] flex items-start flex-col   p-1 border border-Black87">
                    <span className=" font-semibold text-[6pt]"> مجموع هزینه قابل پرداخت توسط گیرنده(ریال):</span>
                    <span className=" mr-1 text-[6pt]">{(item.grossPrice + item.costOfGoods)?.toLocaleString()}</span>
                  </div>

                  <div className=" w-[6cm]   flex flex-1 items-center  p-1 border border-Black87">
                    {!data ? (
                      'بارکد'
                    ) : (
                      <div className="barcodeWrapper">
                        <Barcode
                          height={30}
                          width={1.5}
                          value={item.cprNumber}
                          displayValue={item.senderMobile !== datinNumber}
                          fontSize={10}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="w-[1.5cm] bg-white p-1   flex items-center relative ">
                {!data ? (
                  'بارکد'
                ) : (
                  <div className="!rotate-90 scale-[.65]  barcode-container    absolute  left-[1px]   bottom-[-10px] w-full">
                    <div className="barcodeWrapper">
                      <Barcode
                        width={2.8}
                        height={45}
                        value={item.cprNumber}
                        displayValue={item.senderMobile !== datinNumber}
                        fontSize={16}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          </div>
        ))}

      <style>{`
            @media print {
              @page {
                size: 14cm 9.5cm;
                // margin:0;
                // padding:0 
              }   
            }
            `}</style>
    </>
  );
};

export default PdfTemplate5;
